import { Me } from '@shared/contexts/hooks/useMe';
import { useMeContext } from '@shared/contexts/hooks/useMeContext';
import { IntegrationType } from '@shared/generated/graphql';
import useOrganizationSettings from '@shared/graphql/hooks/organization/useOrganizationSettings';
import { getConfiguredIntegrations } from '@shared/utils/userFeatures/getConfiguredIntegrations';

export const useEnabledLoadboardIntegrations = () => {
  const { me, defaultOrgId } = useMeContext();
  const { settings } = useOrganizationSettings({ id: defaultOrgId ?? '' });
  return getEnabledLoadboardIntegrations(
    me,
    defaultOrgId ?? '',
    (settings?.cover?.availableLoadBoards ?? []) as IntegrationType[]
  );
};

const getEnabledLoadboardIntegrations = (
  me: Me,
  defaultOrgId: string,
  availableLoadBoards: IntegrationType[]
): IntegrationType[] => {
  const loadboardIntegrations = getAvailableLoadboardIntegrations(
    me,
    defaultOrgId
  );

  if (availableLoadBoards.length === 0 && loadboardIntegrations.length > 0) {
    return [loadboardIntegrations[0]];
  }

  return loadboardIntegrations.filter((integration) =>
    availableLoadBoards.includes(integration)
  );
};

const getAvailableLoadboardIntegrations = (
  me: Me,
  defaultOrgId: string
): IntegrationType[] => {
  const loadboardIntegrations = [
    IntegrationType.ALJEX,
    IntegrationType.DAT,
    IntegrationType.HOSTED_MCLEOD,
    IntegrationType.TURVO,
    IntegrationType.REVENOVA,
  ];
  const configuredIntegrations = getConfiguredIntegrations(
    me,
    defaultOrgId ?? ''
  );
  return loadboardIntegrations.filter(
    (integration) => configuredIntegrations[integration]
  );
};
